/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} GeneralInputs */

const en_general = /** @type {(inputs: GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General`)
};

const fr_general = /** @type {(inputs: GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Général`)
};

const de_general = /** @type {(inputs: GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allgemein`)
};

const it_general = /** @type {(inputs: GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generale`)
};

const ru_general = /** @type {(inputs: GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общий`)
};

const es_general = /** @type {(inputs: GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General`)
};

const zh_cn2_general = /** @type {(inputs: GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般的`)
};

const ja_general = /** @type {(inputs: GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般的な`)
};

const hi_general = /** @type {(inputs: GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सामान्य`)
};

const pt_pt2_general = /** @type {(inputs: GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em geral`)
};

/**
* | output |
* | --- |
* | "General" |
*
* @param {GeneralInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const general = /** @type {((inputs?: GeneralInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<GeneralInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_general(inputs)
	if (locale === "de") return de_general(inputs)
	if (locale === "it") return it_general(inputs)
	if (locale === "ru") return ru_general(inputs)
	if (locale === "es") return es_general(inputs)
	if (locale === "zh-CN") return zh_cn2_general(inputs)
	if (locale === "ja") return ja_general(inputs)
	if (locale === "hi") return hi_general(inputs)
	if (locale === "pt-PT") return pt_pt2_general(inputs)
	return en_general(inputs)
});